import { FC } from 'react';

export const AuthPage: FC = () => {
	return <div />;
};
